import PackageForm from "@entities/brief/ui/Influencer/v2/PackageForm";
import { Button, Popover } from "@shared/ui";
import { Plus } from "lucide-react";
import { useState } from "react";
import styles from "./CreateDeliverableFormButton.module.scss";

type CreateDeliverableFormButtonProps = {
  briefId: string;
  onCreated?: () => void;
};

export function CreateDeliverableFormButton({
  briefId,
  onCreated,
}: CreateDeliverableFormButtonProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const closeForm = () => setIsFormOpen(false);

  return (
    <Popover
      open={isFormOpen}
      onOpenChange={setIsFormOpen}
      trigger={["click"]}
      placement="bottomLeft"
      destroyTooltipOnHide
      zIndex={1100}
      getPopupContainer={() => document.body}
      rootClassName={styles.packageFormPopover}
      content={
        <div className={styles.formWrap}>
          <PackageForm
            briefId={briefId}
            isEdit={false}
            isClone={false}
            showTitle
            onCancel={closeForm}
            onBack={closeForm}
            onSuccess={() => {
              closeForm();
              onCreated?.();
            }}
          />
        </div>
      }
    >
      <Button
        type="primary"
        size="small"
        icon={<Plus size={14} />}
        className={styles.triggerButton}
      >
        Create deliverables
      </Button>
    </Popover>
  );
}
